module.exports = __webpack_public_path__ + "static/media/ilhasfalkland.5c0b60dc.jpg";